import React, { Component } from 'react';
import { Navigate } from "react-router-dom";
import {
  Add, 
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import API from "@dndUtilities/system_api";

// import StringBox from "../../../../components/input/strings/StringBox";
import ObjectIndex from "@components/Navigation/ObjectIndex";
import LetterLinks from "@components/Navigation/LetterLinks";

type Props = { }

export interface State { 
  navigateTo: string | null;
  search_string: string;
  start_letter: string;
}

const api = API.getInstance();

class LootTableIndex extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      navigateTo: null,
      search_string: "",
      start_letter: ""
    };
  }

  get_filter() {
    const filter: any = {};
    
    if (this.state.start_letter !== "") {
      filter.start_letter = this.state.start_letter;
    }
    if (this.state.search_string !== "") {
      filter.search_string = this.state.search_string;
    }

    return filter;
  }

  render() {
    if (this.state.navigateTo !== null) {
      return <Navigate to={this.state.navigateTo} />;
    } else {
      return (
        <Grid container spacing={0} direction="column">
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 3
              }}>
              <span className="header">
                Loot Tables
              </span>
              { api.user && 
                <Tooltip title={`Create New Loot Table`}>
                  <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                    onClick={ () => {
                      this.setState({ navigateTo:`/loot_table/create` });
                    }}>
                    <Add/>
                  </Fab>
                </Tooltip> 
              }
            </Grid>
            {/* <Grid item xs={9}>
              <StringBox
                name="Search"
                value={`${this.state.search_string}`}
                onBlur={(search_string: string) => {
                  this.setState({ search_string });
                }}
              />
            </Grid> */}
          </Grid>
          <Grid>
            <ObjectIndex 
              // filter={this.get_filter()}
              data_type="loot_table"
            />
          </Grid>
          <Grid>
            <LetterLinks 
              onChange={(start_letter: string) => {
                this.setState({ start_letter });
              }} 
            />
          </Grid>
        </Grid>
      ); 
    } 
  }
}

export default LootTableIndex;
